import CallToAction from './call-to-action.jsx';
import FloorPrice from './floor-price.jsx';
import FloorPriceUSD from './floor-price-usd.jsx';
import Title from './title.jsx';
import LastUpdated from './last-updated.jsx';
import MarketCap from './market-cap.jsx';
import MarketCapUSD from './market-cap-usd.jsx';
import PriceChange24h from './price-change-24h.jsx';
import SecondarySalesRoyalty from './secondary-sales-royalty.jsx';
import Symbol from './symbol.jsx';
import TotalSupply from './total-supply.jsx';


// Each individual column object.
var callToAction = new CallToAction();
var floorPrice = new FloorPrice();
var floorPriceUSD = new FloorPriceUSD();
var title = new Title();
var lastUpdated = new LastUpdated();
var marketCap = new MarketCap();
var marketCapUSD = new MarketCapUSD();
var priceChange24h = new PriceChange24h();
var secondarySalesRoyalty = new SecondarySalesRoyalty();
var symbol = new Symbol();
var totalSupply = new TotalSupply();


/**
 * Returns an ordered array of the columns in the table.
 */
var Columns = function() {
  var columns = [];

  columns.push(title);
  columns.push(symbol);
  columns.push(totalSupply);
  columns.push(secondarySalesRoyalty);
  columns.push(floorPrice);
  columns.push(floorPriceUSD);
  columns.push(priceChange24h);
  columns.push(marketCap);
  columns.push(marketCapUSD);
  columns.push(callToAction);
  columns.push(lastUpdated);


  return columns;
};


export default Columns;

